// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"127be8e2","455":"21c45c5c","977":"c7d6623c"}[chunkId] + ".chunk.js";
};